import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import {
    isRecordingBanAllowedSelector,
    isRecordingForMembersAllowedSelector,
    setRecordingForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import { SettingsTumbler } from './settings-tumbler';

export const LocalRecordingTumbler: FunctionComponent = () => {
    const hasBanPermission = useSelector(isRecordingBanAllowedSelector);
    const hasMembersPermission = useSelector(isRecordingForMembersAllowedSelector);

    const onChange = useOnPermissionChange(setRecordingForMembersAllowed, 'recording');

    if (!hasBanPermission) {
        return null;
    }

    return (
        <SettingsTumbler
            testId="local-recording-tumbler"
            label={i18n('settings-v2', 'permission-ban-recording')}
            onChange={onChange}
            checked={hasMembersPermission}
        />
    );
};
